import { Box, Container } from "@mui/material";
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { Navigate } from "react-router-dom";
import { useIlpContext } from "../hooks/useIlpContext";
import OrganizationSelectorLandingView from "./OrganizationSelectorLandingView";
import LearnerLandingView from "./LearnerLandingView";
import { LearnerProvider } from "../contexts/LearnerContext";
import AdvisorLandingView from "./AdvisorLandingView";
import { AdvisorProvider } from "../contexts/AdvisorContext";
import NoRoles from "./NoRoles";
import { SpecificPlanProvider } from "../contexts/SpecificPlanContext";
import SpecificPlanLandingView from "./SpecificPlanLandingView";
import { getIlpKeyFromQueryString } from "../../global/utilities/ProcessQueryString";

//This component is responsible for displaying the ilp content.
export default function IlpRouter() {
    const { role, isLearnerFlag, isAdvisorFlag, isAdminFlag, standAloneOrg } = useIlpContext();
    const { selectedOrganization, organizations } = useDuesSponsoredOrgContext();
    const { error } = useErrorContext();

    if (error) {
        return <Navigate to="/error" />;
    }

    const ilpKey = getIlpKeyFromQueryString();

    const renderViewBasedOnRole = () => {
        if (ilpKey != null) {
            return <SpecificPlanProvider><SpecificPlanLandingView /></SpecificPlanProvider>
        }
        if ((!role || role === "unknown" ) && selectedOrganization === undefined) {
            if ((organizations !== undefined && organizations?.length > 0) || (standAloneOrg !== undefined)) {
                return <OrganizationSelectorLandingView />;
            }
            else {
                return <NoRoles />;
            }
        }
        if (isLearnerFlag) {
            return <LearnerProvider><LearnerLandingView /></LearnerProvider>;
        }
        if (isAdvisorFlag || isAdminFlag) {
            return <AdvisorProvider><AdvisorLandingView /></AdvisorProvider>;
        }
        return <NoRoles />
    };

    return (
    <Container>
      <Box>
        {renderViewBasedOnRole()}
      </Box>
    </Container>
    );
}